/**
 * @generated SignedSource<<3143cc055312615a049ca3266140e980>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type appointmentDrawerQuestionnaire_appointment$data = {
  readonly createdAt: string;
  readonly questionnaireCriticalitySummary: {
    readonly useCaseName: string;
  } | null;
  readonly " $fragmentType": "appointmentDrawerQuestionnaire_appointment";
};
export type appointmentDrawerQuestionnaire_appointment$key = {
  readonly " $data"?: appointmentDrawerQuestionnaire_appointment$data;
  readonly " $fragmentSpreads": FragmentRefs<"appointmentDrawerQuestionnaire_appointment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "appointmentDrawerQuestionnaire_appointment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "QuestionnaireCriticalitySummaryOutput",
      "kind": "LinkedField",
      "name": "questionnaireCriticalitySummary",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "useCaseName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};

(node as any).hash = "210a24ad81825bd4b14d502fb306a945";

export default node;
